import { combineReducers } from 'redux';

//定投列表
const inInvestmentList=(state={code:'',message:'',content:{records:[]}}, action) => {
  switch(action.type) {
    case "INVESTMENT_LIST":
      return action.text; 
    default: 
      return state;
  }
}
//定投详情
const inInvestmentDetial=(state={code:'',message:'',content:{records:[],tradeDates:[0]}}, action) => {
  switch(action.type) {
    case "INVESTMENT_DETIAL":
      return action.text; 
    default: 
      return state;
  }
}
const inInvestmentFundList=(state={code:'',message:'',content:[]}, action)=> {
  switch(action.type) {
    case "INVESTMENT_FUN_LIST":
      return action.text; 
    default: 
      return state;
  }
}
const productReducer = combineReducers({
	inInvestmentList,
  inInvestmentFundList,
  inInvestmentDetial
});

export default productReducer;


// WEBPACK FOOTER //
// ./src/reducer/myAssets/InvestPlanReducer.js